var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _g2, _path9, _g3, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefur5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_4072)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5469 34.4173H46.3906V42.4069H34.2292C34.1979 42.584 34.1563 42.7559 34.1042 42.9277H46.3906V49.1413H30.5469V46.3965C30.2083 46.485 29.8542 46.5423 29.5 46.5579V51.0684L31.9167 51.0163L31.9271 51.4017L32.8802 51.5475L32.8958 51.5423C33.099 50.9902 33.6198 50.4382 34.5781 50.4121H34.6198C35.5417 50.4121 36.3177 51.1152 36.4375 52.0059H65.0938V9.05273H29.5V36.4902C29.8594 36.5111 30.2083 36.5632 30.5469 36.6569V34.4173ZM30.5469 17.3913H46.3906V25.3809H30.5469V17.3913ZM30.5469 33.8965V25.9017H46.3906V33.8965H30.5469ZM64.0469 10.0944V49.1413H47.4375V10.0944H64.0469ZM46.3906 10.0944V16.8704H30.5469V10.0944H46.3906Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5316 43.9368V39.6816H47.9482V43.9368H63.5316ZM57.318 40.541V40.9993H54.1618V40.541H57.318Z",
    fill: "#151515"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5316 34.8652H47.9482V39.2246H63.5316V34.8652ZM54.1618 36.0423V35.584H57.318V36.0423H54.1618Z",
    fill: "#151515"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9482 48.5931H63.5316V44.4004H47.9482V48.5931ZM57.318 45.2441V45.7025H54.1618V45.2441H57.318Z",
    fill: "#151515"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1143 61.7604V59.6302H61.0622V58.224H61.5934V57.6719H55.1038V58.224H55.6351V59.6302H52.583V61.7604H64.1143ZM56.1872 58.5H60.5101V59.6302H56.1872V58.5Z",
    fill: "#151515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.583 62.1621H64.1143V65.3704H52.583V62.1621Z",
    fill: "#151515"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_94_4072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 64,
    width: 13,
    height: 5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.833 64H69.833V68.9531H57.833V64Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_94_4072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.765 65.4642L68.1139 65.5892L66.5566 64.1309L65.916 64.2559L66.2285 65.9382L58.6348 67.3496L58.8796 68.6725L66.4785 67.2611L66.791 68.9382L68.7806 68.5684L68.4681 66.8861L69.0098 66.7871L68.765 65.4642Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_94_4072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 4,
    width: 8,
    height: 50
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.833 4.8125H72.4997V53.3333H65.833V4.8125Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_94_4072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.1611 4.94206L67.4424 4.82227L71.9424 51.9056L70.6611 52.0254L66.1611 4.94206Z",
    fill: "#151515"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_94_4072",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 4,
    width: 7,
    height: 50
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 4.8125H74.5156V53.3333H68.5V4.8125Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_94_4072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.7344 4.94206L70.0156 4.82227L74.5156 51.9056L73.2344 52.0254L68.7344 4.94206Z",
    fill: "#151515"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8174 51.9173C11.5986 51.9173 11.3851 51.8913 11.1768 51.8392L12.8591 54.0579L5.91634 56.5475C4.72363 56.9798 4.10384 58.2923 4.53613 59.4798C4.86947 60.4173 5.75488 60.9954 6.69759 60.9954C6.95801 60.9954 7.21842 60.9538 7.47884 60.86L17.3538 57.3184C18.0413 57.0684 18.5726 56.5111 18.7809 55.8132C18.9893 55.1204 18.8486 54.3652 18.4111 53.7819L16.5101 51.2715L12.208 51.8913C12.0778 51.9069 11.9476 51.9173 11.8174 51.9173Z",
    fill: "#151515"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1507 51.4683L18.4267 50.5672L20.8278 59.1922C21.109 60.2079 22.0361 60.8745 23.0465 60.8745C23.2496 60.8745 23.4528 60.8485 23.6611 60.7912C24.8851 60.4526 25.6038 59.187 25.2601 57.9683L24.1246 53.8849L22.6871 53.3068C22.1455 53.0881 21.7288 52.6245 21.5726 52.0672L19.7913 45.7391C19.7861 45.7391 19.7809 45.7391 19.7705 45.7443L11.4892 46.9318C11.4059 46.9474 11.3174 46.9631 11.234 46.9891L11.4319 46.5151L19.6767 45.3329L19.3642 44.2287C19.2288 43.7443 19.2913 43.2339 19.5361 42.7912C19.7861 42.3537 20.1924 42.036 20.6767 41.9006C20.8434 41.8537 21.0205 41.8276 21.1924 41.8276C22.0361 41.8276 22.7861 42.3954 23.0153 43.2079L23.5049 44.9526C24.0413 44.4162 24.3955 43.7756 24.4476 43.1193C24.3174 42.7339 24.2392 42.3433 24.2028 41.9526C23.5413 40.5724 21.7236 39.3745 19.1819 39.9266C15.3642 40.786 13.1611 41.812 9.91631 44.3329C7.68194 46.3589 8.47881 48.2443 9.37465 49.6662C9.52569 49.9058 9.66631 50.1141 9.80173 50.2964C9.81215 50.3172 9.82256 50.3433 9.83819 50.3641C10.2965 51.1401 11.1976 51.6089 12.1507 51.4683Z",
    fill: "#151515"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5833 47.3387C34.1406 47.0939 34.1094 45.7502 33.5677 44.146C33.4635 43.8387 33.3438 43.521 33.2031 43.2033C33.1719 43.1356 33.1406 43.0679 33.1094 43.0002C33.4896 42.0262 33.4948 40.9012 33.0365 39.8699C32.1198 37.7814 29.6771 36.8335 27.5833 37.7449C25.4896 38.6616 24.5365 41.0939 25.4531 43.1772C26.2969 45.0939 28.4167 46.047 30.3802 45.4897C30.25 45.1408 30.125 44.7658 30.0208 44.3699C29.474 42.3022 29.5781 40.4793 30.25 40.2397C29.776 40.7502 29.9896 42.4429 30.7865 44.2554C31.3906 45.6252 32.1667 46.7085 32.8125 47.1564C33.1094 47.3595 33.375 47.4324 33.5833 47.3387Z",
    fill: "#151515"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1819 55.4945C33.4892 54.7445 33.1246 53.8903 32.3694 53.5882L24.6194 50.4632L22.609 43.3226C22.3902 42.5413 21.5777 42.0882 20.7913 42.307C20.01 42.5257 19.5517 43.333 19.7704 44.1142L21.9788 51.9528C22.1038 52.3903 22.4215 52.7445 22.8485 52.9163L31.2652 56.307C31.4475 56.3799 31.635 56.4111 31.8173 56.4111C32.4006 56.4111 32.9475 56.0674 33.1819 55.4945Z",
    fill: "#151515"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9792 62.1096L34.901 58.7502L35.276 58.7398L35.25 57.4377H35.4219L35.4115 57.1356L35.6458 57.1304L35.5312 52.2137C35.5208 51.7137 35.1042 51.3179 34.599 51.3283C33.724 51.3492 33.7031 52.1044 33.7031 52.1044L33.0938 52.5106L31.026 52.1877L31.0208 51.9533L30.0885 51.9742L30.0938 52.219L32.526 53.1981C32.8698 53.3335 33.1458 53.5627 33.349 53.8387L33.3958 53.844L33.401 53.9117C33.7292 54.4117 33.8177 55.0575 33.5729 55.6565C33.5365 55.745 33.4948 55.8283 33.4479 55.9117L33.4688 56.7554L33.8125 56.745L33.8229 57.1721L34.0521 57.1669L34.0625 57.469L34.2344 57.4637L34.2604 58.7658L34.625 58.7554L34.7031 62.1096H0.5V63.2085H49.2031V62.1096H34.9792ZM34.9792 51.9898L35.0208 53.8283H34.8281L34.7865 51.995L34.9792 51.9898ZM34.3333 53.844L34.2917 52.0106L34.4844 52.0054L34.526 53.8387L34.3333 53.844Z",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_4072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefur5);
export default __webpack_public_path__ + "static/media/refur5.0dad88ce6de79cb761cb7db8e199cd7f.svg";
export { ForwardRef as ReactComponent };